import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import Checkbox from 'app/components/general/Checkbox';
import CardGroup from 'app/components/general/CardGroup';
import { Card, CardBody, Collapse } from 'reactstrap';
import { parseAmount } from 'app/utils/parsers';

interface IPlanSummaryProps {
  selected: boolean;
  title: string;
  size: string;
  description: string;
  extraText: string;
  totalAmount: string;
  totalAmountYearly: string;
  handleSelect: Function;
  lineItems: {
    amount: string;
    name: string;
  }[];
  subscription: any;
}
export default class PlanSummary extends React.Component<IPlanSummaryProps> {
  static defaultProps: IPlanSummaryProps = {
    selected: false,
    title: 'Your Plan',
    description: '',
    price: '',
    handleSelect: undefined,
  };

  renderLineItem = (lineItems, billingFrequency): React.ReactNode => _.map(lineItems, (li) => (
    <div className="price-line-item">
      <div className="row">
        <div className="col text-weight-medium">
          {li.name}
        </div>
        <div className="col text-weight-medium-bold text-right">
          {li.amount}
          {' '}
          /
          {' '}
          {billingFrequency}
        </div>
      </div>
    </div>
  ))

  renderLineItems = (lineItems, billingFrequency): React.ReactNode => (
    <div>
      {this.renderLineItem(lineItems, billingFrequency)}
    </div>
  )

  compileLineItems = () => {
    const items = [];
    _.each(this.props.subscription.organisationProducts, (prod) => {
      items.push({
        name: `${prod.name} Plan x ${prod.unitSize} teams`,
        description: prod.description,
        amount: parseAmount(this.props.subscription.monthlyAmount),
        rawAmount: this.props.subscription.monthlyAmount,
      });
    });
    return items;
  }

  totalAmount = (lineItems) => {
    const amount = _.sum(_.map(lineItems, (a) => a.rawAmount));
    return parseAmount(amount);
  }

  render(): React.ReactNode {
    const { subscription } = this.props;
    const lineItems = this.compileLineItems();
    const billingFrequency = subscription.billingFrequency === 'monthly' ? 'month' : 'year';
    const planTitle = `${subscription.name} Plan`;
    return (
      <div
        className="price-summary"
      >
        <div className="row">
          <div className="col">
            <CardGroup className="no-shadow-3" title={planTitle} isOpen>
              <div className="row">
                <div className="col text-left large-text text-weight-bold">
                  {parseAmount(subscription.monthlyAmount)}
                  {' '}
                  /
                  {' '}
                  {billingFrequency}
                </div>
              </div>
              <div className="row margin-top">
                <div className="col">
                  {this.renderLineItems(lineItems, billingFrequency)}
                </div>
              </div>

              <div>
                <div className={classnames('row')}>
                  <div className="col">
                    <div className="text-weight-bold margin-bottom border-bottom padding-bottom">
                      Transaction Fees
                    </div>
                  </div>
                </div>
                <div className="price-line-item">
                  <div className="row">
                    <div className="col text-weight-medium">
                      Credit / debit cards
                    </div>
                    <div className="col text-weight-medium-bold text-right">
                      1.9% + $0.10 per transaction
                    </div>
                  </div>
                </div>
              </div>
              <div className="row with-margin-top">
                <div className="col">
                  All prices are
                  {' '}
                  <span className="text-weight-medium-bold">AUD</span>
                  {' '}
                  and excluding
                  {' '}
                  <span className="text-weight-medium-bold">GST</span>
                  .
                </div>
              </div>
            </CardGroup>

          </div>
        </div>
      </div>
    );
  }
}
